/**
 *  应用系统接口 
 */
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AreasSystemService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 应用系统接口
  /**
   * 查询应用系统所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getAreasSystemList(param) {
    const url = this.prefix + 'system/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看应用系统信息
   * @param param
   * @returns {Observable<any>}
   */
  getAreasSystem(param) {
    const url = this.prefix + 'system/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新应用系统信息
   * @param param
   * @returns {Observable<any>}
   */
  updateAreasSystem(param) {
    const url = this.prefix + 'system/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除应用系统单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteAreasSystem(param) {
    const url = this.prefix + 'system/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加应用系统单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveAreasSystem(param) {
    const url = this.prefix + 'system/save';
    return this.http.Post(url, param);
  }
/**
 * 关联用户 
 * @param param
 * @returns {Observable<any>}
 */
 userSystemQueryByFk(param) {
   const url = this.prefix + 'userSystem/queryByFk';
   return this.http.Post(url, param);
 }

 /**
  * 关联用户保存
  * @param param
  * @returns {Observable<any>}
  */
 saveOrDeleteUserSystem(param) {
   const url = this.prefix + 'userSystem/saveOrDelete';
   return this.http.Post(url, param);
 }

 /**
  * 查询用户列表
  * @param param
  * @returns {Observable<any>}
  */
 userQueryUserList(param) {
   const url = this.prefix + 'user/queryUserList';
   return this.http.Post(url, param);
 }

  /**
  * 查询所有用户列表
  * @param param
  * @returns {Observable<any>}
  */
 userQueryAllUserList(param) {
  const url = this.prefix + 'user/queryAllUserList';
  return this.http.Post(url, param);
}

getAvailableSystemList() {
  const url = this.prefix + 'system/querySystems';
  return this.http.Post(url, null);
}

  //#endregion

}
